import type React from 'react'
import { type ReactElement, useState } from 'react'
import { useUserAcls } from '~/api/queries/user'
import { GlobalMenu } from '~/components/Layout/GlobalMenu/GlobalMenu'
import { getMenu } from '~/components/Layout/GlobalMenu/menu'
import { useConfig } from '~/domains/configuration/queries/config'
import { SettingsMenu } from '../settings/-components/SettingsMenu'
import { SidebarSwitchContext } from './sidebar'

export type GlobalSidebarProps = {
  currentSection: string
  currentPath?: string
  isSettingsRoute: boolean
  currentUserId: number | null
  legacyUrl: string | null
  mainRef?: React.RefObject<HTMLDivElement> | null
}

export const GlobalSidebar = ({
  currentSection,
  currentPath,
  isSettingsRoute,
  currentUserId,
  legacyUrl,
  mainRef
}: GlobalSidebarProps): ReactElement => {
  const [showDashboardMenuOnSettings, setShowDashboardMenuOnSettings] =
    useState(false)
  const { data: userAcls } = useUserAcls(currentUserId ?? null)

  const showDashboardSidebar = !isSettingsRoute || showDashboardMenuOnSettings

  const { data: kanbanDefault } = useConfig('order.kanban_default')
  const { data: invoiceEnabled } = useConfig('finance.invoice_enabled')
  const { data: ordersV3Only } = useConfig('feature_flags.orders_v3_only')
  const { data: applicationsDefaultPage } = useConfig(
    'jobmail.applications_default_page'
  )

  const menu = getMenu(
    userAcls,
    kanbanDefault ?? false,
    invoiceEnabled ?? false,
    ordersV3Only ?? false,
    applicationsDefaultPage === 'v3'
  )

  return (
    <SidebarSwitchContext.Provider
      value={{
        showDashboardMenu: showDashboardMenuOnSettings,
        setShowDashboardMenu: setShowDashboardMenuOnSettings
      }}
    >
      {showDashboardSidebar ? (
        <GlobalMenu
          menu={menu}
          currentSection={currentSection}
          legacyUrl={legacyUrl}
          mainRef={mainRef ?? undefined}
        />
      ) : (
        <SettingsMenu currentPath={currentPath ?? currentSection} />
      )}
    </SidebarSwitchContext.Provider>
  )
}
